import { FC, ReactNode } from "react";
import PaginatedList from "../../PaginatedList";
import WorkCard from "./WorkCard";
import { useSelector } from "react-redux";
import { selectWorks } from "../../../../../slices/works-slice";
import { useTranslation } from "react-i18next";
import WorkCardWithApplication from "./WorkCardWithApplication";
import { WorkListType, WorksState } from "../../../../../domain/models/Work";

interface WorkListProps {
    uploadWorksCallback: () => Promise<void>;
    useCardVersionWithApplication?: boolean;
    customEmptyEntitiesContent?: ReactNode;
    wrapClassName?: string;
    altWorks?: WorksState;
    type: WorkListType;
}

const WorkList: FC<WorkListProps> = (props) => {
    const commonWorks = useSelector(selectWorks);
    const works = props.altWorks || commonWorks;
    const { t } = useTranslation();

    return (
        <div className={`relative flex flex-col dmin2:w-[737px] ${props.wrapClassName || ""}`}>
            <PaginatedList
                entities={works}
                emptyEntitiesContent={
                    props.customEmptyEntitiesContent || (
                        <div className="flex flex-col items-start">
                            <p className="H20B dmax2:H16B text-textWhite text-left">{t("catalog.nothingFound")}</p>
                            <p className="H20 dmax2:H16 text-textFaded text-left">{t("catalog.tryOtherVacancies")}</p>
                        </div>
                    )
                }
                uploadCallback={props.uploadWorksCallback}
                getItemElement={(work) =>
                    props.useCardVersionWithApplication ? (
                        <WorkCardWithApplication key={`work-${work.id}`} work={work} type={props.type} />
                    ) : (
                        <WorkCard key={`work-${work.id}`} work={work} type={props.type} />
                    )
                }
            />
        </div>
    );
};

export default WorkList;
